(ns frontend.ui.component.lp-portal.big-figure.style
  (:require
   [frontend.ui.component.text.style :as text-style]
   [garden.units :refer [px]]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.style.theme.core :refer [color]]))

(defn figure-container
  []
  ^{:media {{:screen :only :max-width (px 991)}
            {:margin-bottom "12px"}}}
  {:text-align     :center
   :display        :flex
   :flex-direction :column})

(defn figure
  []
  ^{:media {{:screen :only :max-width (px 991)}
            {:font-size "36px"}}}
  {:font-size      "72px"
   :font-family    "Palatino LT Pro"
   :letter-spacing "-0.5px"
   :color          (theme/color [:figure :primary :color])
   :font-weight    "bold"})

(defn figure-label
  []
  ^{:extend [text-style/text {}]}
  {:text-transform :uppercase
   :font-weight    :bold
   :font-size      "12px"
   :color          (theme/color [:figure :primary :color])
   :letter-spacing "2.2px"})
